// react
import styled, { css } from 'styled-components';

// components
import { Container, Memphis, MemphisVariant } from '@/components/atoms';
import { BackButton } from '@/components/molecules';

interface ActionPlanHeaderProps {
  className?: string;
  color?: string;
  isBack?: boolean;
  memphis?: MemphisVariant;
}

/**
 * ActionPlanHeader displays a header for the action plan category.
 */
export const ActionPlanHeader = ({
  className,
  color,
  isBack = true,
  memphis = 'elderly-couple-1',
}: ActionPlanHeaderProps) => {
  return (
    <Header className={className} color={color || 'grey'}>
      <Container>
        <HeaderWrapper>
          {isBack && <BackButton isNoMargin />}
          <MemphisWrapper>
            <Memphis size='md' variant={memphis} />
          </MemphisWrapper>
        </HeaderWrapper>
      </Container>
    </Header>
  );
};

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  gap: ${(props) => props.theme.spacing[16]};
`;

const Header = styled.div<{ color: string }>`
  position: relative;
  display: flex;
  align-items: center;

  background: ${(props) =>
    props.theme.color.actionPlanCards[props.color]?.secondary};
  color: ${(props) => props.theme.color.actionPlanCards[props.color]?.primary};
  height: 50px;
  min-height: 50px;
  ${(props) =>
    props.theme.breakpoint.sm(css`
      height: 150px;
      min-height: 150px;
    `)}
  overflow: hidden;
`;

const MemphisWrapper = styled.div`
  display: flex;
  align-items: flex-end;

  height: 100%;
  max-height: 100%;
  flex-shrink: 1;
  flex-grow: 0;
  flex-basis: auto;

  & > * {
    max-height: 100%;
    flex-shrink: 1;
    flex-grow: 0;
    flex-basis: auto;
  }
`;

ActionPlanHeader.displayName = 'ActionPlanHeader';

export default ActionPlanHeader;
